import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core'
import { UiStepperStepComponent } from '../ui-stepper-step/ui-stepper-step.component'

@Component({
    selector: 'mg-ui-stepper',
    templateUrl: './ui-stepper.component.html',
    styleUrls: ['./ui-stepper.component.scss'],
})
export class UiStepperComponent implements AfterContentInit {
    @ContentChildren(UiStepperStepComponent) steps: QueryList<UiStepperStepComponent>

    constructor() {}

    private _activeIndex = 0

    @Input() isConfiguratorVersion: boolean = false

    @Input()
    get activeIndex() {
        return this._activeIndex
    }

    set activeIndex(index: number) {
        this._activeIndex = index
        this.syncActiveIndex()
    }

    syncActiveIndex() {
        if (this.steps) {
            const { activeIndex } = this
            this.steps.forEach((step, index) => {
                step.isActive = index === activeIndex
            })
        }
    }

    ngAfterContentInit() {
        const initialActiveStep = this.steps.find(({ isActive }) => isActive)

        if (!initialActiveStep) {
            this.syncActiveIndex()
        } else {
            this.activeIndex = this.steps.toArray().indexOf(initialActiveStep)
        }
    }
}
